export default "__VITE_ASSET__10d10a3e__"